import { PURCHASE_INTENT_PARAM, type PurchaseIntent } from '@/lib/constants/issue-report';

/**
 * A path that keeps the purchase intent in its query string (FR-206): login's
 * "Sign up" link and signup's "Log in" link use it so the intent survives the
 * hop. Pure; with no intent the path is returned unchanged.
 *
 * @param path   an app path with no query string of its own
 * @param intent the intent in force, or null
 */
export function withPurchaseIntent(path: string, intent: PurchaseIntent | null): string {
  return intent ? `${path}?${PURCHASE_INTENT_PARAM}=${encodeURIComponent(intent)}` : path;
}
